import React, { Component } from "react";
import DialogBaseView from "../../../../components/DialogBase/DialogBaseView";
import DialogPromptView from "../../../../components/DialogBase/components/DialogPrompt/DialogPromptView";
import DialogSelectView from "../../../../components/DialogBase/components/DialogSelect/DialogSelectView";
import TranslationView from "../../../../../../components/translation/TranslationView";
import DialogTextInputView from "../../../../components/DialogBase/components/DialogTextInput/DialogTextInputView";
import { getKeys } from "../../../../../../../lib/Enums";
import GSMProblemAction from '../../../../../../../models/constants/GSMProblemAction';
import { MenuItem } from "@material-ui/core";
import GSMProblemDialogViewProps from './GSMProblemDialogViewProps';
import GSMProblemDialogViewState from "./GSMProblemDialogViewState";

export default class GSMProblemDialogView extends Component<GSMProblemDialogViewProps, GSMProblemDialogViewState> {

    state = {
        gsmNumber: '',
        selectedAction: undefined
    };

    render() {
        const { errors } = this.props;

        return (
            <DialogBaseView title='GSMProblem' subtitle='GSMTurnedOff' onSubmit={this.onSubmit} error={errors.form}>
                <DialogPromptView style={{ marginBottom: 20 }}>
                    <TranslationView>
                        pleaseUpdateGSMNumber
                    </TranslationView>
                </DialogPromptView>

                <DialogTextInputView
                    style={{ width: '50%', marginBottom: 30 }}
                    placeholder='GSMNumber'
                    onChange={this.onGSMNumberChange}
                    error={errors.gsmNumber} />

                <DialogPromptView style={{ marginBottom: 20 }}>
                    <TranslationView>
                        noOtherGSMNumber
                    </TranslationView>
                </DialogPromptView>

                <DialogSelectView placeholder='chooseAnOption' value={this.state.selectedAction} error={errors.action} onChange={this.onActionChange}>
                    <MenuItem key={undefined} value={undefined}>
                        <span style={{ height: 18 }} />
                    </MenuItem>
                    {getKeys(GSMProblemAction).map((action, index) => (
                        <MenuItem key={index} value={index}>
                            <TranslationView>
                                {action}
                            </TranslationView>
                        </MenuItem>
                    ))}
                </DialogSelectView>
            </DialogBaseView>
        );
    }

    onGSMNumberChange = (text: string) => {
        this.setState({
            gsmNumber: text
        });
    }

    onActionChange = (value: number) => {
        this.setState({
            selectedAction: value
        });
    }

    onSubmit = (done: () => void) => {
        this.props.onSubmit(this.state, done);
    }
}